export default __webpack_public_path__ + "static/media/E-WEB-Goal-06.74efcd0f.png";